import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from '@/components/ui/sonner';

export function PublicLayout() {
    return (
        <div className="cl-public-shell min-h-screen flex flex-col">
            <a className="cl-skip-link" href="#main-content">Zum Inhalt springen</a>
            <Navbar />
            <main id="main-content" className="flex-1" tabIndex="-1">
                <Outlet />
            </main>
            <Footer />
            <Toaster position="top-right" />
        </div>
    );
}

export default PublicLayout;
